var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXCircleMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0002 4.00004C9.37275 4.00004 4.00016 9.37262 4.00016 16C4.00016 22.6275 9.37275 28 16.0002 28C22.6276 28 28.0002 22.6275 28.0002 16C28.0002 9.37262 22.6276 4.00004 16.0002 4.00004ZM1.3335 16C1.3335 7.89986 7.89999 1.33337 16.0002 1.33337C24.1003 1.33337 30.6668 7.89986 30.6668 16C30.6668 24.1002 24.1003 30.6667 16.0002 30.6667C7.89999 30.6667 1.3335 24.1002 1.3335 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9426 11.0572C21.4633 11.5778 21.4633 12.4221 20.9426 12.9428L12.9426 20.9428C12.4219 21.4635 11.5777 21.4635 11.057 20.9428C10.5363 20.4221 10.5363 19.5778 11.057 19.0572L19.057 11.0572C19.5777 10.5365 20.4219 10.5365 20.9426 11.0572Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.057 11.0572C11.5777 10.5365 12.4219 10.5365 12.9426 11.0572L20.9426 19.0572C21.4633 19.5778 21.4633 20.4221 20.9426 20.9428C20.4219 21.4635 19.5777 21.4635 19.057 20.9428L11.057 12.9428C10.5363 12.4221 10.5363 11.5778 11.057 11.0572Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircleMobile);
export default __webpack_public_path__ + "static/media/x-circle-mobile.6bd338dc1dee7ea6e4dd77ce8cafebdd.svg";
export { ForwardRef as ReactComponent };